import * as ReactHelmetAsync from 'react-helmet-async';
const Helmet = ReactHelmetAsync.Helmet || (ReactHelmetAsync as any).default?.Helmet;
import { Clock, Mail } from 'lucide-react';
import { Navigation } from '@/components/layout/Navigation';
import { Footer } from '@/components/layout/Footer';
import { PageHero } from '@/components/sections/PageHero';
import { useHomeData } from '@/hooks/useHomeData';

export function Pricing() {
  const { homeData } = useHomeData();

  return (
    <>
      <Helmet>
        <title>Flight Training Pricing | Total Tailwheel</title>
        <meta
          name="description"
          content="Tailwheel training pricing: $220/hr aircraft + $80/hr instruction. Most endorsements completed in 5-10 hours. Professional flight instruction in our Cessna 170B."
        />
        <meta name="keywords" content="tailwheel training cost, flight instruction pricing, tailwheel endorsement cost, flight school rates Massachusetts" />
        <meta property="og:title" content="Flight Training Pricing | Total Tailwheel" />
        <meta property="og:description" content="Professional tailwheel training pricing - $220/hr aircraft + $80/hr instruction. Contact us for details." />
        <link rel="canonical" href="https://totaltailwheel.com/pricing" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        <Navigation />
        
        <PageHero title="Pricing" />

        {/* Pricing Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-3xl font-medium text-primary text-center mb-8">
                {homeData.pricing.title}
              </h2>
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                {homeData.pricing.packages.map((pkg, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
                    <div className="bg-primary p-6">
                      <h3 className="text-xl text-white font-medium">{pkg.title}</h3>
                      <div className="mt-4 text-3xl font-light text-white">
                        {pkg.price}
                        <span className="text-lg">{pkg.unit}</span>
                      </div>
                    </div>
                    <div className="p-6">
                      <p className="text-foreground/80">{pkg.description}</p>
                      {pkg.note && (
                        <>
                          <div className="h-px w-full bg-gray-200 my-4"></div>
                          <p className="text-foreground/80">{pkg.note}</p>
                        </>
                      )}
                      {pkg.feature && (
                        <div className="flex items-center mt-8">
                          <Clock size={20} className="text-primary mr-2" />
                          <span className="text-foreground/60 text-sm">{pkg.feature}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Total Cost Information */}
              <div className="bg-white border border-primary/20 rounded-lg p-8 text-center">
                <h3 className="text-2xl font-medium text-primary mb-4">Total Training Cost</h3>
                <div className="text-4xl font-light text-primary mb-4">$300<span className="text-xl">/hour</span></div>
                <p className="text-foreground/80 mb-6">
                  Combined aircraft rental ($220) + instruction ($80) per flight hour
                </p>
                <p className="text-foreground/60 text-sm mb-8">
                  Most tailwheel endorsements are completed in 5-10 hours of training
                </p>

                {/* Contact Information */}
                <div className="bg-primary/10 border border-primary/30 rounded-lg px-6 py-4">
                  <p className="text-sm text-primary/70 font-medium mb-2">Ready to get started?</p>
                  <div className="flex items-center justify-center">
                    <Mail className="text-primary mr-2" size={20} />
                    <a 
                      href={`mailto:${homeData.footer.email}`}
                      className="text-lg font-semibold text-primary hover:text-primary/80 transition-colors"
                    >
                      {homeData.footer.email}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}